'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasNewUnseenMessage = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _incrementUnseenCount = require('../../actions/ConversationsActions/incrementUnseenCount');

var _postShowPageTitleNotification = require('../../page-title-notifications/actions/post-message/postShowPageTitleNotification');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasNewUnseenMessage = exports.hasNewUnseenMessage = function hasNewUnseenMessage(_ref) {
  var channel = _ref.channel;
  return function (dispatch) {
    dispatch((0, _incrementUnseenCount.incrementUnseenCount)({ channel: channel }));

    dispatch((0, _postShowPageTitleNotification.postShowPageTitleNotification)({
      title: _I18n2.default.text('conversationsVisitorUIPageTitleNotifications.newMessage')
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/last-seen/actions/hasNewUnseenMessage.js
// module id = 441
// module chunks = 2 3